import { IsEnum, IsBoolean, IsOptional, IsObject } from 'class-validator'
import { NotificationChannel, NotificationTopic } from '../enums'

export class SetNotifPrefDto {
  @IsEnum(NotificationChannel)
  channel!: NotificationChannel

  @IsEnum(NotificationTopic)
  topic!: NotificationTopic

  @IsBoolean()
  enabled!: boolean

  @IsOptional()
  @IsObject()
  config?: Record<string, unknown>
}

export class ListNotifPrefsDto {
  @IsOptional()
  @IsEnum(NotificationChannel)
  channel?: NotificationChannel

  @IsOptional()
  @IsEnum(NotificationTopic)
  topic?: NotificationTopic
}
